/* eslint-disable */
// @ts-nocheck

/**
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as GoogleProtobufEmpty from '../../../google/protobuf/empty.pb';
import * as GoogleProtobufTimestamp from '../../../google/protobuf/timestamp.pb';
import * as EdukitaPaulaBackendCommonFilter from '../common/filter.pb';
import * as EdukitaPaulaBackendGaragecacheProfiles from '../garagecache/profiles.pb';
import * as fm from '@generated/fetch.pb';

export enum SessionStatus {
    SESSION_STATUS_UNSPECIFIED = 'SESSION_STATUS_UNSPECIFIED',
    SESSION_STATUS_FUTURE = 'SESSION_STATUS_FUTURE',
    SESSION_STATUS_TODAY = 'SESSION_STATUS_TODAY',
    SESSION_STATUS_FEEDBACK_NEEDED = 'SESSION_STATUS_FEEDBACK_NEEDED',
    SESSION_STATUS_DONE = 'SESSION_STATUS_DONE',
}

export type ScheduleCounts = {
    feedbackNeeded?: number;
    today?: number;
    tomorrow?: number;
    thisWeek?: number;
};

export type GetScheduleRequest = {
    garageSessionStartTimeDateGte?: string;
    garageSessionStartTimeDateLte?: string;
    garageCourseTitle?: string;
    garageCourseLevelLabels?: string[];
    garageSessionTeacherIds?: number[];
    garageSessionStartTimeHourGte?: string;
    garageSessionStartTimeHourLte?: string;
    garageCourseType?: string;
    garageCourseSubtype?: string;
    sessionStatus?: string;
};

export type Schedule = {
    garageSessionId?: number;
    garageClassroomId?: number;
    garageCourseId?: number;
    garageCourseTitle?: string;
    garageCourseLevelLabel?: string;
    garageSessionStartTime?: GoogleProtobufTimestamp.Timestamp;
    garageSessionEndTime?: GoogleProtobufTimestamp.Timestamp;
    garageTeacherProfile?: EdukitaPaulaBackendGaragecacheProfiles.GarageTeacherProfile;
    garageCourseType?: string;
    garageCourseSubtype?: string;
    sessionStatus?: string;
    currentSessionNumber?: number;
    unitSessionNumber?: number;
    isOffline?: boolean;
    subject?: string;
};

export type GetScheduleResponse = {
    schedules?: Schedule[];
    counts?: ScheduleCounts;
};

export type GetScheduleFiltersResponse = {
    filters?: EdukitaPaulaBackendCommonFilter.FilterDefinition[];
};

export class ScheduleV2 {
    static GetScheduleFilters(
        this: void,
        req: GoogleProtobufEmpty.Empty,
        initReq?: fm.InitReq
    ): Promise<GetScheduleFiltersResponse> {
        return fm.fetchRequest<GetScheduleFiltersResponse>(
            `/v2/schedule/filters?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
    static GetScheduleV2(
        this: void,
        req: GetScheduleRequest,
        initReq?: fm.InitReq
    ): Promise<GetScheduleResponse> {
        return fm.fetchRequest<GetScheduleResponse>(
            `/v2/schedule?${fm.renderURLSearchParams(req, [])}`,
            { ...initReq, method: 'GET' }
        );
    }
}
